import Rest from './base/Rest';

export default class ApiBankingCredentialService extends Rest {
	static resource = 'pixcredential';

    listAll() {
        this.relationship = 'listAll';
        return this;
    }

    save() {
        this.relationship = 'save';
        return this;
    }

    listOne() {
        this.relationship = 'listOne';
        return this;
    }

    update() {
        this.relationship = 'update';
        return this;
    }
}
